import './index.scss';

/* globals MediaElementPlayer */

const audioEntities = document.querySelectorAll('audio');
audioEntities.forEach((entity) => new MediaElementPlayer(entity, {
  alwaysShowControls: true,
  audioHeight: 71,
  audioVolume: 'vertical',
  audioWidth: '100%',
  features: [
    'playpause',
    'progress',
    'current',
    'duration',
    'volume',
  ],
  preload: 'auto',
}));
